import { render } from "./DevPanel.vue?vue&type=template&id=4dca4c8c&scoped=true"
import script from "./DevPanel.vue?vue&type=script&lang=js"
export * from "./DevPanel.vue?vue&type=script&lang=js"

import "./DevPanel.vue?vue&type=style&index=0&id=4dca4c8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dca4c8c"]])

export default __exports__